import { Editor } from "codemirror";
import * as React from "react";
import { useState } from "react";

import { Add } from "@livechat/design-system-icons";
import { ActionMenu, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";

import { ContentType } from "../constants";

import { pickerItems } from "./pickerItems";

interface IParameterSelectProps {
  editor: React.RefObject<null | Editor>;
  contentType: ContentType;
  disabled: boolean;
}

export const ParameterSelect: React.FC<IParameterSelectProps> = ({ editor, contentType, disabled }) => {
  const [parametersVisible, setParametersVisible] = useState(false);

  const handleVariableSelect = (item: string): void => {
    const parameter = pickerItems(contentType).find(i => i.key === item);

    if (!parameter) {
      return;
    }

    if (editor.current) {
      const doc = editor.current.getDoc();
      const cursor = doc.getCursor();
      doc.replaceRange(parameter.props.value, cursor);
      editor.current.focus();
    }

    trackEngagement("HTML template editor: Add variable from list", EventPlace.Settings, {
      variableAdded: parameter.key,
    });

    setParametersVisible(false);
  };

  const toggleParametersVisibility = (): void => {
    setParametersVisible(visible => !visible);
  };

  const options: IActionMenuOption[] = pickerItems(contentType).map(item => ({
    key: item.key,
    element: item.props.name,
    onClick: () => handleVariableSelect(item.key),
  }));

  return (
    <ActionMenu
      visible={parametersVisible}
      options={options}
      onClose={toggleParametersVisibility}
      triggerRenderer={
        <Button
          data-testid="add-variable"
          disabled={disabled}
          icon={<Icon source={Add} />}
          iconPosition="left"
          onClick={toggleParametersVisibility}
          kind="secondary"
          size="compact"
        >
          Add Variable
        </Button>
      }
    />
  );
};
